import { useReadOnly } from 'utils/lifecycle'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Button, Typography } from '@mui/material'
import * as uiActions from 'modules/UI/actions'
import { AuthPopupEnum } from 'utils/constants'
import CreateAlertDialog from 'modules/Account/modules/Alerts/CreateAlertDialog'

const CreateAlert = ({ alertConfig }) => {
  const readOnly = useReadOnly()
  const dispatch = useDispatch()
  const userDetails = useSelector((state) => state.user.details)
  const [open, setOpen] = useState(false)
  const [continueAfterLogin, setContinueAfterLogin] = useState(false)

  useEffect(() => {
    if (continueAfterLogin && userDetails?.userId) {
      setContinueAfterLogin(false)
      setOpen(true)
    }
  }, [continueAfterLogin, userDetails])

  const initialValue = useMemo(() => {
    const common = { radius: alertConfig.radius || 15 }
    if (alertConfig.businessId) {
      return {
        ...common,
        type: 'BUSINESS',
        business: {
          businessId: Number(alertConfig.businessId),
          businessName: alertConfig.businessName || `Business ${alertConfig.businessId}`,
        },
      }
    }
    if (alertConfig.selectedCategory) {
      return {
        ...common,
        type: 'CATEGORY',
        category: { name: alertConfig.selectedCategory },
      }
    }
    return { ...common, type: 'KEYWORD', keyword: alertConfig.query || '' }
  }, [alertConfig])

  const createAlert = () => {
    if (!userDetails?.userId) {
      setContinueAfterLogin(true)
      dispatch(uiActions.showLogin(AuthPopupEnum.register))
      return
    }
    setOpen(true)
  }

  return (
    <>
      <Typography variant="body2" color="text.secondary">
        There are no offers yet. Create an alert and we will email you when new matching offers arrive.
      </Typography>
      <Box mt={3}>
        <Button disabled={readOnly} color="primary" variant="contained" onClick={createAlert}>Create alert</Button>
      </Box>
      <CreateAlertDialog
        open={open && !readOnly}
        onClose={() => setOpen(false)}
        initialValue={initialValue}
      />
    </>
  )
}

export default CreateAlert
